import { redMat } from '@/Interfaces/common';

export function getParentSection(objs) {
    const collisionObj = objs?.filter((item) => item?.getNumberSection() === 1);
    if (!collisionObj.length) return null;

    for (const item of collisionObj) {
        if (getMaxIndexSection(item.model) >= 3) continue;
        return item.model;
    }
    return null;
}
export function getMaxIndexSection(res) {
    return res?.children.filter(x => x.name.includes('_s'))?.length ?? 0;
}
export function setRedMark(res) {
    return res?.children
        ?.filter(x => x.name.includes('_s'))
        ?.filter(x => x.material = redMat);
}
